import { INavData } from '@coreui/angular';

export const navItems: INavData[] = [
  {
    name: 'Dashboard',
    url: '/dashboard',
    iconComponent: { name: 'cil-speedometer' },
  },
  {
    name: 'Search End User',
    url: '/user',
    iconComponent: { name: 'cil-user' },
  },
  {
    name: 'Marketing page',
    url: '/marketing',
    iconComponent: { name: 'cil-https' },
  },
  {
    name: 'Settings',
    url: '/settings',
    iconComponent: { name: 'cilSettings' },
  },
  {
    name: 'Stream settings',
    url: '/streaming',
    iconComponent: { name: 'cil-media-play' },
  }
];
